import decodeEntities from './lib/decodeEntities';

export default decodeEntities;
